import { useParams } from 'react-router-dom';

import useGetContractDetails from '@/hooks/contract/useGetContractDetails.hook';
import { EDITABLE_STATUS_KEYS, VARIABLE_TYPE } from '@/config/statuses.config';
import useGetContractLinesFromCache from '@/hooks/contract/useGetContractLinesFromCache.hook';
import OptionButton from '@/components/common/OptionButton/OptionButton';
import ArrowIcon from '@/components/common/OptionButton/icons/Arrow/ArrowIcon';
import useRaiseProformaByBillingCycles from './hooks/useRaiseProformabyBillingCycles';

export default function ProformaInvoicingContainer() {
  const { contractId }: { contractId: UUID } = useParams();
  const { contract } = useGetContractDetails(contractId);
  const { raiseProformaByBillingCycles } = useRaiseProformaByBillingCycles(contractId);
  const { contractHasActiveSubscriptionLines } = useGetContractLinesFromCache(contractId);

  const isVisible = contract &&
    contractHasActiveSubscriptionLines &&
    EDITABLE_STATUS_KEYS.includes(contract.status.status) &&
    !contract.billingType.includes(VARIABLE_TYPE);

  const onClick = () => {
    raiseProformaByBillingCycles();
  };

  if (!isVisible) {
    return null;
  }

  return (
    <OptionButton
      onClick={onClick}
      Icon={<ArrowIcon />}
    >
      Raise Proforma
    </OptionButton>
  );
}
